const SUPABASE_ERROR_CODES = {
  EMAIL_NOT_VERIFIED: 'email_not_verified',
  EMAIL_TAKEN: 'user_already_exists',
  INVALID_CREDENTIALS: 'invalid_credentials',
  SAME_PASSWORD: 'same_password',
  WEAK_PASSWORD: 'weak_password'
};

// eslint-disable-next-line import/prefer-default-export
export { SUPABASE_ERROR_CODES };
